.container {
  position: relative;
  min-width: 0;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
}

.scroll {
  overflow-x: auto;
  border-radius: inherit;
}

.scrollY {
  overflow-y: auto;
}

.scroll:focus-visible {
  outline-offset: 2px;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: var(--font-size-md);
  font-variant-numeric: tabular-nums;
}

.caption {
  padding: var(--space-3) var(--space-4);
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
  text-align: left;
  caption-side: top;
}

.selectCol {
  width: 3rem;
}

.headerCell {
  padding: var(--space-2-5) var(--space-4);
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-surface-sunken);
  color: var(--color-text-muted);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.02em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
  vertical-align: middle;
}

.sticky thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.sortButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  margin: calc(-1 * var(--space-1)) calc(-1 * var(--space-1-5));
  padding: var(--space-1) var(--space-1-5);
  border-radius: var(--radius-sm);
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
}

.sortButton:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.sortIcon {
  display: inline-flex;
  opacity: 0.55;
}

.sorted {
  color: var(--color-text);
}

.sorted .sortIcon {
  opacity: 1;
  color: var(--color-link);
}

.right .sortButton {
  flex-direction: row-reverse;
}

.cell {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text);
  text-align: left;
  vertical-align: middle;
}

.rowHeader {
  font-weight: var(--font-weight-medium);
}

.compact .cell {
  padding-top: var(--space-1-5);
  padding-bottom: var(--space-1-5);
}

.compact .headerCell {
  padding-top: var(--space-2);
  padding-bottom: var(--space-2);
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}

.center {
  text-align: center;
}

.row:last-child .cell,
.row:last-child .selectCell {
  border-bottom: 0;
}

.row:hover .cell,
.row:hover .selectCell {
  background-color: var(--color-surface-hover);
}

.selected .cell,
.selected .selectCell,
.selected:hover .cell,
.selected:hover .selectCell {
  background-color: var(--color-surface-selected);
}

.clickable {
  cursor: pointer;
}

.selectCell {
  width: 3rem;
  padding: 0 var(--space-2) 0 var(--space-4);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

thead .selectCell {
  background-color: var(--color-surface-sunken);
}

.rowButton {
  display: inline;
  padding: 0;
  color: var(--color-link);
  font: inherit;
  font-weight: var(--font-weight-medium);
  text-align: inherit;
}

.rowButton:hover {
  text-decoration: underline;
}

.stateCell {
  padding: 0;
}
